import router from 'source/router/index';
import axios from 'source/lib/axios';
import sileo from 'sileo';
import eventBus from 'source/lib/event-bus';

const Company = new sileo.Model('bposeats', 'employer-company');
const EmployerBookings = new sileo.Model('bposeats', 'employer-bookings');
const Campaign = new sileo.Model('bposeats', 'campaign');
const SimpleCampaign = new sileo.Model('bposeats', 'simple-campaign');
const CampaignInitialData = new sileo.Model('bposeats', 'campaign-initial-data');
const FacilityBooking = new sileo.Model('bposeats', 'facility-booking');
// DEPRECATED
// const InvitedApplicants = new sileo.Model('bposeats', 'booking-invited-applicants');
const EmployeeCount = new sileo.Model('bposeats', 'employee-count');
const DashboardEmployee = new sileo.Model('bposeats', 'employment-dashboard-employee');
const FetchAdminStaff = new sileo.Model('bposeats', 'fetch-staff');
const Employer = new sileo.Model('bposeats', 'employer-profile-settings');
const BIRinfo = new sileo.Model('bposeats', 'employer-bir-information');
const Recording = new sileo.Model('bposeats', 'recording');
// DEPRECATED:
// const ApplicantInvitationStatus = new sileo.Model('bposeats', 'booking-invitation-status');
const Employment = new sileo.Model('bposeats', 'employer-employment');
const SeparationForNonPremiumEmployment = new sileo.Model('bposeats', 'separation-for-non-premium');
const HRAdmin = new sileo.Model('bposeats', 'company-settings-hr-admin');
const CompanyRules = new sileo.Model('bposeats', 'company-settings-company-rules');
const CompanyBenefits = new sileo.Model('bposeats', 'company-settings-company-benefits');
const Benefits = new sileo.Model('bposeats', 'company-settings-benefits');
const Province = new sileo.Model('bposeats', 'province');
const Municipality = new sileo.Model('bposeats', 'municipality');
const BookingContract = new sileo.Model('bposeats', 'employer-booking-contract');
const BookingContractCompany = new sileo.Model('bposeats', 'employer-booking-contract-company');
const BookingContractFacility = new sileo.Model('bposeats', 'employer-booking-contract-facility');
const PayrollPeriod = new sileo.Model('bposeats', 'employer-payroll-period');
const EmployeePayroll = new sileo.Model('hqzen', 'employee-payroll-summary');
const PremiumEmployeePayroll = new sileo.Model('bposeats', 'employer-premium-employee-payroll');
const Authentication = new sileo.Model('bposeats', 'authentication');
const EmployerID = new sileo.Model('bposeats', 'employer-id');
const EmployerIDAmazonFormData = new sileo.Model('bposeats', 'employer-id-amazon-form-data');
const EmploymentContractCompleteAddress = new sileo.Model('bposeats', 'employment-contract-complete-address');
const CompanyOperation = new sileo.Model('bposeats', 'employer-company-operation');
const CompanySettingsCompanyOperation = new sileo.Model('bposeats', 'company-settings-company-operations');
const EmployerPayrollIssues = new sileo.Model('bposeats', 'employer-employee-payroll-issues');
const EmployerEmployeeTimeLogDates = new sileo.Model('bposeats', 'employer-employment-time-log-shifts');
const UpdateHandout = new sileo.Model('bposeats', 'update-handout');
const ArchiveUpdate = new sileo.Model('bposeats', 'archive-update');
const EmployeePayrollHistory = new sileo.Model('bposeats', 'employer-employee-payroll-history');
const Amenities = new sileo.Model('bposeats', 'amenities');
const EmployerThreads = new sileo.Model('bposeats', 'employer-messages-thread');
const EmployeeJobScheduleGroup = new sileo.Model('bposeats', 'employee-job-schedule-group');
const JobScheduleGroup = new sileo.Model('bposeats', 'job-schedule-group');
const JobPostingJobScheduleGroup = new sileo.Model('bposeats', 'job-posting-job-schedule-group');
const HRJobScheduleGroup = new sileo.Model('applybpo', 'hr-job-schedule-group');
const HqzenJobScheduleGroup = new sileo.Model('hqzen', 'job-schedule-group');
const WorkScheduleEmployee = new sileo.Model('bposeats', 'work-schedule-employees');
const CompanySettingsWorkSchedule = new sileo.Model('bposeats', 'company-settings-work-schedule');
const Building = new sileo.Model('bposeats', 'building');
const AmenityReservation = new sileo.Model('bposeats', 'amenity-reservation');
const AmenityReservationWithDate = new sileo.Model('bposeats', 'amenity-reservation-date');
const JobPosting = new sileo.Model('bposeats', 'job-postings');
const JobPostingSidebar = new sileo.Model('bposeats', 'job-postings-sidebar');
const JobPostingDetails = new sileo.Model('bposeats', 'job-posting-details');
const AmazonFormData = new sileo.Model('bposeats', 'job-posting-banner-amazon-form-data');
const CompanyAvatarAmazonCredentials = new sileo.Model('bposeats', 'employer-avatar-amazon-form-data');
const CompanyAvatarAmazonUnauthenticatedCredentials = new sileo.Model(
    'bposeats', 'employer-avatar-amazon-form-data-unauthenticated');
const ApplicantJobPostingApplications = new sileo.Model('bposeats', 'applicant-job-posting-applications');
const Screenshots = new sileo.Model('bposeats', 'screenshots');
const TimeLogShiftActivity = new sileo.Model('bposeats', 'employee-timelog-activity');
const CompanyAllEmployees = new sileo.Model('bposeats', 'company-all-employees');
const ApplicantNote = new sileo.Model('bposeats', 'applicant-note');
const ApplicantFiles = new sileo.Model('bposeats', 'requirements');
const CompanySettingsDesktopAppFeaturesEnabled = new sileo.Model(
    'bposeats', 'company-settings-desktop-app-features-allowed');
const CompanySettingsDepartments = new sileo.Model('bposeats', 'company-settings-departments');
const CompanySettingsTeams = new sileo.Model('bposeats', 'company-settings-teams');
const EmploymentRule = new sileo.Model('bposeats', 'employment-rules');
const EmployeeDepartment = new sileo.Model('bposeats', 'employee-departments');
const EmployeeTeam = new sileo.Model('bposeats', 'employee-teams');
const EmployerEmployeeExitInterview = new sileo.Model('bposeats', 'employment-exit-interviews');
const ExitInterview = new sileo.Model('bposeats', 'exit-interviews');
const WebsiteRestrictionEmployees = new sileo.Model('bposeats', 'website-restriction-employees');
const WebsiteRestriction = new sileo.Model('bposeats', 'website-restrictions');
const StaffingBalance = new sileo.Model('bposeats', 'staffing-balance');
const EmployeeFiles = new sileo.Model('bposeats', 'employee-files');
const EmployeeIncidentReports = new sileo.Model('bposeats', 'employee-files-incident-reports');
const EmployeePCNs = new sileo.Model('bposeats', 'employee-pcns');
const EmployeeDAFs = new sileo.Model('bposeats', 'employee-dafs');
const ArchiveEmployeeContract = new sileo.Model('bposeats', 'archive-employee-contract');
const Executive = new sileo.Model('bposeats', 'executive');
const ExecutiveVerification = new sileo.Model('bposeats', 'executive-verification');
const JobPostingApplications = new sileo.Model('bposeats', 'job-applications-section');
const RejectJobOfferRequest = new sileo.Model('bposeats', 'reject-job-offer-request');
const RecruitmentApplicant = new sileo.Model('hqzen', 'recruitment-applicant');
const JobPostingTitleFilters = new sileo.Model('bposeats', 'job-posting-title-filters');
const ClientWorkforceJobApplication = new sileo.Model('bposeats', 'client-workforce-job-application');
const EmploymentInformation = new sileo.Model('bposeats', 'simple-employment-information');
const JobScheduleGroupList = new sileo.Model('bposeats', 'schedule-list');
const TimeLogs = new sileo.Model('timelogging', 'timelogs');
const JobPostingBuilding = new sileo.Model('bposeats', 'job-posting-buildings');
const Leaves = new sileo.Model('bposeats', 'employer-employee-payroll-period-leaves');
const JobPostingFeed = new sileo.Model('hqzen', 'job-postings-feed');
const JobPostingFeedDetails = new sileo.Model('hqzen', 'job-posting-feed-details');
const JobPostingCompanies = new sileo.Model('hqzen', 'job-posting-companies');
const EmployeePayrolls = new sileo.Model('hqzen', 'employee-payrolls');
const EmployeeContractCount = new sileo.Model('bposeats', 'job-offer-accepted-contract');
const OnboardingEmployeeInformation = new sileo.Model('hqzen', 'employee-details');
const OnboardingEmployeeContractInformation = new sileo.Model('bposeats', 'employment-contract');
const EmploymentBlockUnblock = new sileo.Model('bposeats', 'employment-block-unblock');
// New Location Constants from Public Job Posting
const Constants = new sileo.Model('hqzen', 'constants');
const Countries = new sileo.Model('hqzen', 'countries');
const CountrySubdivisions = new sileo.Model('hqzen', 'country-subdivisions');
const AuthorizeGoogle = new sileo.Model('bposeats', 'authorize-google');
const UpdateScheduledInterviewStatus = new sileo.Model('bposeats', 'update-scheduled-interviews-status');
const CheckConflictingScheduledInterview = new sileo.Model('bposeats', 'check-conflicting-scheduled-interviews');

const FreeEmployee = new sileo.Model('hqzen', 'free-employee');
const WorkforceNonExecutiveEmployees = new sileo.Model('hqzen', 'workforce-non-executives');
const ExistingUserByEmail = new sileo.Model('hqzen', 'existing-employee-email');
const ExistingPhoneNumber = new sileo.Model('hqzen', 'existing-employee-number');

// Staff Configurations (Administration)
const PlatformSettingsList = new sileo.Model('hqzen', 'platform-settings-list');
const PlatformSettingsDetails = new sileo.Model('hqzen', 'platform-settings-details');
const StaffConfigurationEmploymentPolicy = new sileo.Model('hqzen', 'staff-configuration-employment-policy');
const StaffConfigurationEmploymentPolicyList = new sileo.Model('hqzen', 'staff-configuration-employment-policy-list');
const RenameStaffConfiguration = new sileo.Model('hqzen', 'rename-staff-configuration');
const StaffConfigurationList = new sileo.Model('hqzen', 'staff-configuration-list');
// const StaffConfigDetails = new sileo.Model('hqzen', 'staff-configuration-details');

// Send Job offer request workflow
const JobOfferRequest = new sileo.Model('bposeats', 'job-offer-request');

const BlockedPartnersList = new sileo.Model('bposeats', 'blocked-partners-list');

const BusinessPartnerInvite = new sileo.Model('hqzen', 'business-partner-invite');
const BusinessExistingPartnerByEmail = new sileo.Model('hqzen', 'business-existing-partner-email');
const BusinessPartnerList = new sileo.Model('hqzen', 'business-partner-list');

const state = {
    company: null,
    employerID: null,
    employerBookings: [],
    departments: [],
    campaigns: [],
    selectedCampaignPK: null,
    bookingDetails: null,
    facilityBooking: {},
    booking: null,
    employeesCount: 0,
    provinces: {},
    municipalities: {},
    bookingContract: {},
    previousPayrollPeriods: {},
    previousPayrollPeriodsCount: 0,
    offeredApplicant: null
};

const getters = {
    company: state => state.company,
    employerID: state => state.employerID,
    employeesCount: state => state.employeesCount,
    offeredApplicant: state => state.offeredApplicant,
    previousPayrollPeriods: state => state.previousPayrollPeriods,
    previousPayrollPeriodsCount: state => state.previousPayrollPeriodsCount
};

const mutations = {
    setOfferedApplicant(state, offeredApplicant) {
        state.offeredApplicant = offeredApplicant;
    },

    setProvinces(state, provinces) {
        state.provinces = provinces;
    },

    setMunicipalities(state, municipalities) {
        state.municipalities = municipalities;
    },

    resetEmployerStates(state) {
        state.company = null;
        state.employerBookings = [];
        state.bookingDetails = null;
        state.booking = null;
        state.employeesCount = 0;
    },

    setCompany(state, company) {
        state.company = company;
    },

    setEmployerID(state, id) {
        state.employerID = id;
    },

    setEmployerBookings(state, payload) {
        state.employerBookings = payload;
    },

    setBookingDetails(state, payload) {
        state.bookingDetails = payload;
    },

    setEmployeesCount(state, count) {
        state.employeesCount = count;
    },

    setBookingContract(state, contract) {
        state.bookingContract = contract;
    },

    setPreviousPayrollPeriods(state, data) {
        state.previousPayrollPeriods['page-' + data.page] = [...data.payrollPeriods];
    },

    setPreviousPayrollPeriodsCount(state, count) {
        state.previousPayrollPeriodsCount = count;
    },

    setStaffingBalance(state, data) {
        state.company.company_balance = { ...data };
    },

    setCampaigns(state, data) {
        state.campaigns = [...data];
    }
};

const actions = {

    async getAuthorizedGoogleLink(context, email) {
        const form = new FormData();
        form.append('email', email);
        return await AuthorizeGoogle.objects.create(form);
    },

    async fetchConstants(context, filters) {
        return await Constants.objects.filter(filters).then(data => {
            return data[0];
        });
    },

    async fetchCountries(context, filters) {
        return await Countries.objects.filter(filters);
    },

    async fetchCountrySubdivisions(context, filters) {
        return await CountrySubdivisions.objects.filter(filters);
    },

    fetchProvinces({ commit }, filters = {}) {
        return Province.objects.filter(filters).then(function (data) {
            commit('setProvinces', data);
            return data;
        });
    },

    fetchMunicipalities({ commit }, province = null) {
        const filters = {};
        if (province) {
            filters.province__pk = province;
        }
        return Municipality.objects.filter(filters).then(function (data) {
            commit('setMunicipalities', data);
            return data;
        });
    },

    fetchContractCount(context, filter) {
        return EmployeeContractCount.objects.filter(filter);
    },

    fetchCompanyOperationsMunicipalities(context, province = null) {
        const filters = {};
        if (province) {
            filters.province__pk = province;
        }
        return Municipality.objects.filter(filters).then(function (data) {
            return data;
        });
    },

    getCompany({ commit }) {
        Company.objects.get(1).then(function (data) {
            commit('setEmployeesCount', data.employees_count);
            commit('setCompany', data);
        }).catch(err => {
            console.error(err);
        });

        return;
    },

    fetchEmployerBookings({ commit }) {
        EmployerBookings.objects.filter().then(function (data) {
            commit('setEmployerBookings', data);
        });
    },

    fetchCampaigns({ state }) {
        Campaign.objects.filter({ company_id: state.company.pk });
    },

    fetchSimpleCampaigns({ commit }, payload) {
        return SimpleCampaign.objects.filter(payload).then(function (data) {
            commit('setCampaigns', data);
            return data;
        });
    },

    fetchCampaign(context, pk) {
        return Campaign.objects.get(pk);
    },

    fetchCampaignInitialData(context, pk) {
        return CampaignInitialData.objects.get(pk);
    },

    getDashboardEmployee(context, pk) {
        return DashboardEmployee.objects.get(pk).catch(response => {
            return response;
        });
    },

    separateEmploymentFromCompany(context, pk) {
        return SeparationForNonPremiumEmployment.objects.update({ 'employment_pk': pk });
    },

    fetchEmployeeCount(context, filters = {}) {
        return EmployeeCount.objects.filter(filters).then(data => {
            return data;
        }).catch(response => {
            console.error(response);
        });
    },

    fetchDashboardEmployees(context, filters = {}) {
        return DashboardEmployee.objects.filter(filters).then(data => {
            return data;
        }).catch(response => {
            console.error(response);
        });
    },

    fetchAdminStaff(context, filters = {}) {
        return FetchAdminStaff.objects.filter(filters);
    },

    updateDashboardEmployee(context, employee_data) {
        const form = new FormData();

        form.append('action', employee_data.action.toLowerCase());
        form.append('employment_id', employee_data.pk);

        if (form.get('action') == 'overtime-eligibility') {
            form.append('overtime_allowed', employee_data.overtimeAllowed);
        } else {
            if (form.get('action') != 'end' || form.get('action') !== 'change-job-title') {
                form.append('salary_currency', employee_data.currency);
                form.append('monthly_salary', employee_data.newMonthlySalary);
                form.append('is_management', employee_data.isManagement);
                form.append('start_date', employee_data.startDate);
            }

            if (form.get('action') === 'change-job-title') {
                form.append('job_position', employee_data.jobPosition);
            }
        }

        return DashboardEmployee.objects.update({ 'employment_id': employee_data.pk }, form).
            then(response => {
                if (form.get('action') != 'end' &&
                    form.get('action') != 'update' &&
                    form.get('action') != 'change-job-title' &&
                    form.get('action') != 'raise' &&
                    form.get('action') != 'overtime-eligibility'
                ) {
                    router.go(-1);
                } else {
                    return response;
                }
            }).catch(response => {
                console.error(response);
                return response;
            });
    },

    checkRaiseValidity(context, employee_data) {
        let filters = {
            raise_currency_code: employee_data.currency,
            raise_monthly_salary: employee_data.newMonthlySalary,
            raise_start_date: employee_data.startDate,
            employment_id: employee_data.pk,
        };

        return DashboardEmployee.objects.filter(filters).
            then(response => {
                return response;
            }).catch(response => {
                console.error(response);
            });
    },

    fetchRecordingByApplicantId(context, { top = 0, applicantId = null, campaignId = null }) {
        let filters = {
            applicant__pk: applicantId,
            interview_round__campaign__pk: campaignId
        };
        return Recording.objects.filter(filters, { top }).catch(response => {
            console.error(response);
            return response;
        });
    },

    // Components using this function is not used
    // fetchInvitationStatusByInvitationApplicant(context, filters) {
    //     return ApplicantInvitationStatus.objects.filter(filters).then(data => data[0]).catch(response => {
    //         return response;
    //     });
    // },

    // createInvitationForApplicant(context, data) {
    //     const form = new FormData();

    //     form.append('campaign_id', data.campaign_id);
    //     form.append('applicant_id', data.applicant_id);
    //     form.append('booking_id', data.booking_id);

    //     return ApplicantInvitationStatus.objects.create(form);
    // },

    fetchEmploymentByApplicantCompanyIds(context, filters = {}) {
        return Employment.objects.filter(filters).then(data => data.objects[0]);
    },

    fetchEmploymentByApplicantIds(context, filters = {}) {
        return Employment.objects.filter(filters);
    },

    fetchEmploymentByApplicantIds(context, filters = {}) {
        return Employment.objects.filter(filters);
    },

    fetchRecordingById(context, pk) {
        return Recording.objects.get(pk);
    },

    fetchHRAdminAccountData(context, email) {
        return HRAdmin.objects.filter({ company__user_profile__user__email: email });
    },

    fetchCompanyRulesData(context, email) {
        return CompanyRules.objects.filter({ company__user_profile__user__email: email });
    },

    fetchCompanyBenefitsData(context, email) {
        return CompanyBenefits.objects.filter({ user_profile__user__email: email });
    },

    getEmployerAccountData(context, pk) {
        return Employer.objects.get(pk);
    },

    fetchRecruitmentApplicantData(context, filters) {
        return RecruitmentApplicant.objects.filter(filters);
    },

    fetchBenefits() {
        return Benefits.objects.filter();
    },

    fetchBIRInformationData() {
        return BIRinfo.objects.filter();
    },

    fetchCompanyCountryPk() {
        return Company.objects.get(1).then(company => {
            return company.country.pk;
        });
    },

    fetchCompanyCountry() {
        return Company.objects.get(1).then(company => {
            return company.country;
        });
    },

    updateEmployerAccount(context, data) {
        const form = new FormData();
        for (let key in data) {
            if (key !== 'pk') {
                form.append(key, data[key]);
            }
        }
        return Employer.objects.update({}, form).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    },

    updateHRAdminAccount(context, data) {
        const form = new FormData();
        form.append('username', data.username);
        form.append('email', data.email);
        form.append('phone_number', data.phone_number);
        form.append('phone_country_code', data.phone_country_code);

        HRAdmin.objects.update({}, form).then(function (data) {
            if (data.status === 200) {
                eventBus.$emit('employers:settings:company:success', 'HR Profile Successfully Updated');
            } else if (data.status === 400) {
                throw data.error;
            }
        }).catch(function (error) {
            eventBus.$emit('employers:settings:account:error', error);
        });
    },

    updateBIRInformation(context, data) {
        const form = new FormData();
        for (let key in data) {
            if (data[key] == null) {
                form.append(key, '');
            } else {
                form.append(key, data[key]);
            }
        }

        return BIRinfo.objects.update({}, form).then(function (data) {
            if (data.error) {
                return data.error;
            } else {
                return data;
            }
        }).catch(function (error) {
            return error;
        });
    },

    updateCompanyRules(context, data) {
        const form = new FormData();
        form.append('strict_time', data.tfa_required);
        form.append('require_nda', data.tfa_required);
        form.append('tfa_required', data.tfa_required);
        form.append('payroll_arrears', data.tfa_required);
        form.append('thirteenth_month', data.tfa_required);

        return CompanyRules.objects.update({}, form).then(function (data) {
            return data;
        }).catch(function (error) {
            return error;
        });
    },

    updateCompanyBenefits(context, data) {
        const form = new FormData();
        form.append('benefits', data);

        CompanyBenefits.objects.update({}, form).then(function (data) {
            if (data.status === 200) {
                eventBus.$emit('employers:settings:company:success', 'Company Benefits Successfully Updated');
            } else if (data.status === 400) {
                throw data.error;
            }
        }).catch(function (error) {
            eventBus.$emit('employers:settings:company:error', error);
        });
    },

    resetEmployerPassword(context, data) {
        return axios.post('employers/password-reset/', { data: data });
    },

    async fetchBookingContract({ commit }, pk) {
        return await BookingContract.objects.get(pk).then(function (response) {
            if (!response.error) {
                commit('setBookingContract', response);
            }
            return response;
        }).catch(function (response) {
            return response;
        });
    },

    fetchBookingContractCompany() {
        return BookingContractCompany.objects.get(0);
    },

    submitBookingContract(context, data) {
        const [signature, booking_id, employerName, citizenship, postalAddress, location] = data;

        return new Promise((res) => {
            signature.save(async (blob) => {
                const formData = new FormData();
                formData.append('signature', blob);
                formData.append('employerName', employerName);
                formData.append('citizenship', citizenship);
                formData.append('postalAddress', postalAddress);
                formData.append('location', location);
                let response = await BookingContract.objects.update({ pk: booking_id }, formData);
                res(response);
            });
        });
    },

    fetchEmployerID({ state, commit }) {
        if (state.bookingContract.pk) {
            return EmployerID.objects.filter({ booking_contract__pk: state.bookingContract.pk }).then(data => {
                if (data.status != 400) {
                    commit('setEmployerID', data);
                } else {
                    commit('setEmployerID', null);
                }
                return data;
            });
        }
        commit('setEmployerID', null);
        return null;
    },

    submitEmployerID(context, key) {
        const formData = new FormData();
        formData.append('key', key);
        formData.append('booking_contract_id', state.bookingContract.pk);

        return EmployerID.objects.create(formData);
    },

    fetchFacilityBooking({ state }, booking_id) {
        let facilityBooking = FacilityBooking.objects.get(booking_id);
        if (facilityBooking.end_date == 'None') {
            facilityBooking.end_date = '';
        }
        state.facilityBooking = facilityBooking;
    },

    updateFacilityBooking(content, data) {
        let form = new FormData();

        if (data.date) {
            form.append('end_date', data.date);
        }

        return FacilityBooking.objects.update({ 'pk': data.booking_id }, form);
    },

    fetchBookingContractFacility(context, pk) {
        return BookingContractFacility.objects.get(pk);
    },

    // Components using this function is not used
    // fetchInvitedApplicantById(context, pk) {
    //     return InvitedApplicants.objects.get(pk).catch(response => {
    //         return response;
    //     });
    // },

    fetchEmployeePayrollHistory(context, filters) {
        return EmployeePayrollHistory.objects.filter(filters);
    },

    checkIfCSVGenerateJobStarted(_, params) {
        return axios
            .get('applybpo/employee_payrolls/check-generate-csv-started', {
                params
            })
            .then(response => response);
    },

    checkCSVUploadStatus(context, params) {
        return axios.get('applybpo/employee_payrolls/csv-upload-status', {
            params: params
        }).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },

    generatePayrollHistoryCSV(context, params) {
        return axios.get('applybpo/employee_payrolls/generate-payroll-history-csv', {
            params: params
        }).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },

    generateCommissionAccountsCSV(context, params) {
        return axios.get('bposeats/employee_payrolls/generate-commision-accounts-csv', {
            params: params
        });
    },

    fetchPayrollPeriod(context, pk) {
        return PayrollPeriod.objects.get(pk).catch(response => {
            return response;
        });
    },

    fetchPremiumEmployeePayrolls(context, filters) {
        return PremiumEmployeePayroll.objects.filter(filters).catch(response => {
            return response;
        });
    },

    fetchPayrollIssues(context, filters) {
        return EmployerPayrollIssues.objects.filter(filters);
    },

    fetchEmployeeTimeLogDates(context, filters) {
        return EmployerEmployeeTimeLogDates.objects.filter(filters)
            .catch(response => {
                return response;
            });
    },

    getEmployeePayroll(context, id) {
        return EmployeePayroll.objects.get(id)
            .catch(response => {
                return response;
            });
    },

    myDepartmentEmployeePayroll(context, id) {
        return EmployeePayrolls.objects.get(id)
            .catch(response => {
                return response;
            });
    },

    fetchOnboardingEmployeeInformation(context, id) {
        return OnboardingEmployeeInformation.objects.get(id)
            .catch(response => {
                return response;
            });
    },

    fetchOnboardingEmployeeContractInformation(context, filter) {
        return OnboardingEmployeeContractInformation.objects.filter(filter)
            .catch(response => {
                return response;
            });
    },

    switchEmployeePayroll(context, filters) {
        return EmployeePayrolls.objects.filter(filters)
            .catch(response => {
                return response;
            });
    },

    generateAuthCode(context, phoneDetails) {
        const form = new FormData();
        form.append('phone_country_code', phoneDetails.phoneCountryCode);
        form.append('phone_number', phoneDetails.phoneNumber);

        return Authentication.objects.create(form).then(function (data) {
            if (data.status == 200) {
                localStorage.setItem('tfa_token', data.tfa_token);
                return data;
            } else {
                eventBus.$emit('employers:settings:update:error', data.message);
            }
        });
    },

    verifyCode(context, code) {
        return Authentication.objects.filter({ code: code, token: localStorage.getItem('tfa_token') });
    },

    resendCode() {
        return Authentication.objects.update({ token: localStorage.getItem('tfa_token') }).then(function (data) {
            if (data.status == 200) {
                localStorage.setItem('tfa_token', data.tfa_token);
                return data;
            }
        });
    },

    async fetchEmployerIDAmazonFormData(context, filters = {}) {
        let data = await EmployerIDAmazonFormData.objects.filter(filters);
        return data.amazon;
    },

    async fetchCompleteAddressByFacilityPk(context, facilityPk) {
        return EmploymentContractCompleteAddress.objects.filter({ 'facilities__id': facilityPk });
    },

    fetchCompanyOperations() {
        return CompanyOperation.objects.filter();
    },

    updateCompanyInfoAndOperations(context, { companyData, operations }) {
        const form = new FormData();
        for (let key in companyData) {
            if (companyData[key] == null) {
                form.append(key, '');
            } else {
                form.append(key, companyData[key]);
            }
        }

        const stringified_operations = JSON.stringify(operations);
        form.append('operations', stringified_operations);

        return CompanyOperation.objects.update({}, form);
    },

    updateCompanySettingsCompanyInfoAndOperations(context, { companyData, operations }) {
        const form = new FormData();
        for (let key in companyData) {
            if (companyData[key] == null) {
                form.append(key, '');
            } else {
                form.append(key, companyData[key]);
            }
        }

        const stringified_operations = JSON.stringify(operations);
        form.append('operations', stringified_operations);

        return CompanySettingsCompanyOperation.objects.update({}, form);
    },

    submitAnnouncementSignature(context, data) {
        const [update_pk, signature, location] = data;
        return new Promise((resolve) => {
            signature.save(async (blob) => {
                const formData = new FormData();
                formData.append('signature', blob);
                formData.append('location', location);
                resolve(await UpdateHandout.objects.update({ 'pk': update_pk }, formData));
            });
        });
    },

    fetchArchiveUpdates(context, data) {
        return ArchiveUpdate.objects.filter(data);
    },

    fetchArchiveEmployeeContracts(context, data) {
        return ArchiveEmployeeContract.objects.filter(data);
    },

    fetchJobPostingApplications(context, filters) {
        return JobPostingApplications.objects.filter(filters)
            .catch(response => {
                console.error(response);
                return response;
            });
    },

    updateJobPostingApplication(context, application_data) {
        return JobPostingApplications.objects.update({}, application_data).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            throw error;
        });
    },

    rejectJobOfferRequest(context, data) {
        const formData = new FormData();
        formData.append('pk', data.pk);
        formData.append('rejection_reason', JSON.stringify(data.rejection_reason));

        return RejectJobOfferRequest.objects.update({}, formData);
    },

    blockParter(context, data) {
        let formData = new FormData();

        Object.keys(data).forEach(key => {
           formData.append(key, data[key]);
        });

        return EmploymentBlockUnblock.objects.create(formData);
    },

    updateEmploymentBlockUnblock(context, data) {
        return EmploymentBlockUnblock.objects.update({ pk: data.pk }, data);
    },

    createJobPostingApplication(context, data) {
        const form = new FormData();

        for (let field in data) {
            form.append(field, data[field]);
        }

        return JobPostingApplications.objects.create(form).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            throw error;
        });
    },

    removeJobPostingApplication(context, filters) {
        return JobPostingApplications.objects.delete(filters).then(response => {
            return response;
        }).catch(error => {
            console.error(error);
            return error;
        });
    },


    fetchJobPostingTitleFilterOptions(context, filters) {
        return JobPostingTitleFilters.objects.filter(filters)
            .catch(response => {
                console.error(response);
                return response;
            });
    },

    async fetchAmenity(context, amenity_id) {
        return await Amenities.objects.get(amenity_id).then(data => {
            return data;
        }).catch(response => {
            return response || null;
        });
    },

    async createJobScheduleGroup(context, data) {
        const formData = new FormData();
        for (let key in data) {
            if (key === 'schedules') {
                data[key] = JSON.stringify(data[key]);
            }
            formData.append(key, data[key]);
        }

        return await HqzenJobScheduleGroup.objects.create(formData).catch(response => {
            return JSON.parse(response.responseText).data;
        });
    },

    async editJobScheduleGroup(context, data) {
        const formData = new FormData();
        for (let key in data) {
            if (key === 'schedules') {
                data[key] = JSON.stringify(data[key]);
            }
            formData.append(key, data[key]);
        }

        return await HRJobScheduleGroup.objects.update(formData).catch(response => {
            console.error(response);
        });
    },

    async fetchWorkScheduleEmployees(context, data) {
        return await WorkScheduleEmployee.objects.filter({}, data).then(data => {
            return data;
        }).catch(response => {
            console.error(response);
        });
    },

    fetchJobScheduleGroups(context, data) {
        return JobScheduleGroup.objects.filter({}, data);
    },

    updateJobScheduleGroup(context, data) {
        const formData = new FormData();
        for (let key in data) {
            if (key === 'schedules') {
                data[key] = JSON.stringify(data[key]);
            }
            formData.append(key, data[key]);
        }

        return HRJobScheduleGroup.objects.update({}, data);
    },

    fetchJobPostingJobScheduleGroup(context, data) {
        return JobPostingJobScheduleGroup.objects.filter({}, data);
    },

    fetchEmployeeDepartments(context, filters) {
        return EmployeeDepartment.objects.filter(filters);
    },

    fetchEmployeeTeams(context, filters) {
        return EmployeeTeam.objects.filter(filters);
    },

    async getJobScheduleGroup(context, pk) {
        return await JobScheduleGroup.objects.get(pk).then(response => {
            return response;
        }).catch(response => {
            console.error(response);
        });
    },

    async deleteJobScheduleGroup(context, pk) {
        const form = new FormData();
        form.append('is_active', false);
        return await JobScheduleGroup.objects.update({ 'pk': pk }, form).
            catch(response => {
                console.error(response);
            });
    },

    async updateWorkScheduleEmployees(context, data) {
        const form = new FormData();
        form.append('employees', JSON.stringify(data.employees));
        form.append('deleted_employees', JSON.stringify(data.deleted_employees));

        try {
            return await WorkScheduleEmployee.objects.update(
                { 'workforce_id': data.workforce_id },
                form
            );
        } catch (response) {
            const text = response.responseText || await response.text();
            const parsed = JSON.parse(text);
            throw new Error(parsed?.data?.error || 'An unexpected error occurred.');
        }
    },

    async getEmployeeJobScheduleGroup(context, pk) {
        return await EmployeeJobScheduleGroup.objects.get(pk).then(response => {
            return response;
        }).catch(response => {
            console.error(response);
        });
    },

    async updateEmployeeJobScheduleGroup(context, filters) {
        return await EmployeeJobScheduleGroup.objects.update(filters);
    },

    fetchCompanySettingsWorkSchedule(context, data) {
        return CompanySettingsWorkSchedule.objects.filter(data).then(response => {
            return response[0];
        });
    },

    async updateCompanySettingsWorkSchedule(context, data) {
        const form = new FormData();
        form.append('company', JSON.stringify(data.company));
        return await CompanySettingsWorkSchedule.objects.update({}, form)
            .then(response => {
                return response;
            }).catch(response => {
                console.error(response);
                return response;
            });
    },

    fetchBuildingInfo(context, data) {
        return Building.objects.filter(data);
    },

    fetchAmenityReservations(context, data) {
        return AmenityReservation.objects.filter(data);
    },

    fetchAmenityReservationsWithDate(context, data) {
        return AmenityReservationWithDate.objects.filter(data);
    },

    cancelReservation(context, data) {
        return AmenityReservation.objects.update(data);
    },

    reserveAmenity(context, data) {
        const form = new FormData();
        form.append('workforce_pk', data.workforce_pk);
        form.append('amenity_pk', data.amenity_pk);
        form.append('date', data.date);
        form.append('start_time', data.start_time);
        form.append('end_time', data.end_time);
        form.append('purpose', data.purpose);
        form.append('remarks', data.remarks);

        return AmenityReservation.objects.create(form);
    },

    createMessageThread(context, data) {
        return EmployerThreads.objects.create(data);
    },

    async fetchAmazonFormData() {
        return await AmazonFormData.objects.filter().then(amazon => {
            return amazon.amazon;
        });
    },

    async createJobPosting(context, data) {
        const form = new FormData();

        if (!data.schedule_pk) delete data.schedule_pk;
        if (!data.country_id) delete data.country_id;
        if (!data.province_id) delete data.province_id;

        Object.keys(data).forEach(key => {
            form.append(key, data[key]);
        });

        return JobPosting.objects.create(form);
    },

    fetchJobPostings(context, filters) {
        return JobPostingSidebar.objects.filter(filters).catch(response => {
            console.error(response);
        });
    },

    getSidebarJobPosting(context, pk) {
        return JobPostingSidebar.objects.get(pk);
    },

    async getJobPostingFeedDetails(context, pk) {
        return await JobPostingFeedDetails.objects.get(pk);
    },

    fetchJobPostingById(context, pk) {
        return JobPosting.objects.get(pk);
    },

    fetchJobPostingDetails(context, pk) {
        return JobPostingDetails.objects.get(pk);
    },

    fetchJobPostingCompanies(context, filters) {
        return JobPostingCompanies.objects.filter(filters);
    },

    updateJobPostingLiveStatus(context, data) {
        return JobPostingDetails.objects.update({
            action: data.action,
            job_posting_pk: data.job_posting_pk
        }, {
            is_live: data.is_live
        });
    },

    async updateJobPostingEditInformation(context, data) {
        const form = new FormData();

        if (!data.schedule_pk) delete data.schedule_pk;
        if (!data.country_id) delete data.country_id;
        if (!data.province_id) delete data.province_id;

        const keys = Object.keys(data).filter(key => {
            return key !== 'job_posting_pk' && key !== 'data.action';
        });
        keys.forEach(key => {
            form.append(key, data[key]);
        });

        let filters = {
            action: data.action,
            job_posting_pk: data.job_posting_pk
        };

        if (data.sub_action) {
            filters['sub_action'] = data.sub_action;
        }

        return JobPostingDetails.objects.update(filters, form);
    },

    fetchNonExecutiveWorkforceEmployees(context, filters) {
        return WorkforceNonExecutiveEmployees.objects.filter(filters);
    },

    async fetchCompanyAvatarAmazonFormData() {
        return await CompanyAvatarAmazonCredentials.objects.filter().then(amazon => {
            return amazon.amazon;
        });
    },

    async fetchCompanyAvatarAmazonFormDataUnauthenticated() {
        return await CompanyAvatarAmazonUnauthenticatedCredentials.objects.filter().then(amazon => {
            return amazon.amazon;
        });
    },

    async fetchApplicantJobPostingApplications(context, filters) {
        return ApplicantJobPostingApplications.objects.filter(filters);
    },

    fetchScreenshots(context, filters) {
        return Screenshots.objects.filter(filters);
    },

    fetchTimeLogShiftActivities(context, filters) {
        return TimeLogShiftActivity.objects.filter(filters);
    },

    fetchCompanyAllEmployees(context, filters) {
        return CompanyAllEmployees.objects.filter(filters);
    },

    fetchApplicantNotes(context, filters) {
        return ApplicantNote.objects.filter(filters);
    },

    async fetchApplicantFiles(context, filters) {
        return ApplicantFiles.objects.filter(filters);
    },

    fetchEmployeeFiles(context, filters) {
        return EmployeeFiles.objects.filter(filters);
    },

    fetchIncidentReports(context, filters) {
        return EmployeeIncidentReports.objects.filter(filters);
    },

    fetchEmployeePCNs(context, filters) {
        return EmployeePCNs.objects.filter(filters);
    },

    fetchEmployeeDAFs(context, filters) {
        return EmployeeDAFs.objects.filter(filters);
    },

    getCompanyDesktopAppFeaturesEnabled(context, id) {
        return CompanySettingsDesktopAppFeaturesEnabled.objects.filter({ user_profile_id: id });
    },

    fetchCompanySettingsDepartments(context, id) {
        return CompanySettingsDepartments.objects.filter({ company__user_profile_id: id });
    },

    fetchCompanySettingsTeams(context, data) {
        let filters = {
            company__user_profile_id: data.profile_id,
        };
        if (data.department_id) {
            filters['department_id'] = data.department_id;
        }
        return CompanySettingsTeams.objects.filter(filters);
    },

    fetchEmploymentRules(context, filters) {
        return EmploymentRule.objects.filter(filters);
    },

    async updateOrCreateEmploymentRule(context, data) {
        const form = new FormData();
        form.append('name', data.name);
        form.append('position', data.position);
        form.append('employee_type', data.employee_type);
        form.append('compensation_type', data.compensation_type);
        form.append('can_overtime', data.can_overtime ? 'True' : 'False');
        form.append('overtime_rate', data.overtime_rate);
        form.append('can_file_overtime_after_shift', data.can_file_overtime_after_shift ? 'True' : 'False');
        form.append('auto_overtime', data.auto_overtime ? 'True' : 'False');
        form.append('is_leave_policy_activated', data.is_leave_policy_activated ? 'True' : 'False');

        if (data.compensated_days) {
            form.append('compensated_days', data.compensated_days);
        }

        if (data.employment_pk != undefined && data.employment_pk != null) {
            form.append('employment_pk', data.employment_pk);
        }

        if (data.employment_rule_pk) {
            form.append('employment_rule_pk', data.employment_rule_pk);
        }

        if (data.leave_credit) {
            form.append('leave_credit', data.leave_credit);
        }

        return await EmploymentRule.objects.create(form);
    },

    async fetchEmploymentsExitInterview(context, filters) {
        return await EmployerEmployeeExitInterview.objects.filter(filters);
    },

    async fetchExitInterview(context, filters) {
        return await ExitInterview.objects.filter(filters).catch(response => {
            console.error(response);
        });
    },

    fetchWebsiteRestrictionEmployees(context, filters) {
        return WebsiteRestrictionEmployees.objects.filter(filters);
    },

    fetchRestrictedWebsites(context, filters) {
        return WebsiteRestriction.objects.filter(filters);
    },

    createWebsiteRestriction(context, data) {
        const form = new FormData();
        form.append('websites', JSON.stringify(data.websites));
        form.append('employment_pks', data.employeesPk);

        return WebsiteRestriction.objects.create(form);
    },

    updateWebsiteRestriction(context, data) {
        const form = new FormData();
        form.append('employment_pks', data.employeesPk);
        form.append('name', data.name);
        form.append('site_url', data.siteUrl);

        return WebsiteRestriction.objects.update({ pk: data.sitePk }, form);
    },

    deleteWebsiteRestriction(context, filters) {
        return WebsiteRestriction.objects.delete(filters);
    },

    updateStaffingBalance({ commit }, pk) {
        return StaffingBalance.objects.get(pk)
            .then(response => {
                commit('setStaffingBalance', response);
                return response;
            });
    },

    fetchExecutiveInvites(context, filters) {
        let top = filters.top;
        delete filters.top;
        return Executive.objects.filter(filters, { top: top });
    },

    createExecutiveInvite(context, data) {
        const form = new FormData();
        form.append('first_name', data.first_name);
        form.append('last_name', data.last_name);
        form.append('email', data.email);
        form.append('avatar_key', data.avatar_key);
        if (data.phone_number.length) {
            form.append('phone_country_code', data.phone_country_code);
            form.append('phone_number', data.phone_number);
        }
        return Executive.objects.create(form).then(function (data) {
            return data;
        });
    },

    fetchExecutiveVerificationInfo(context, filters) {
        return ExecutiveVerification.objects.filter(filters).then(data => {
            return data;
        }).catch(err => {
            return err;
        });
    },

    setExecutivePassword(context, payload) {
        let { filters, data } = payload;
        const form = new FormData();
        form.append('password', data.password);
        form.append('confirm_password', data.confirm_password);
        form.append('region', data.region);
        form.append('workforce_id', data.workforce_id);
        return ExecutiveVerification.objects.update(filters, form);
    },

    updateExecutive(context, data) {
        const form = new FormData();
        form.append('action', data.action);
        form.append('company_id', data.companyPk);

        return Executive.objects.update({ 'pk': data.executivePk }, form);
    },

    fetchEmploymentInformation(context, pk) {
        return EmploymentInformation.objects.get(pk).then(
            data => {
                return data;
            }
        ).catch(
            response => {
                console.error(response);
            }
        );
    },

    fetchEmployeeJobSchedules(context, filters) {
        return JobScheduleGroupList.objects.filter(filters);
    },

    fetchPayrollPeriodTimeLogs(context, filters) {
        return TimeLogs.objects.filter(filters);
    },

    fetchJobPostingBuildings(context, filters) {
        return JobPostingBuilding.objects.filter(filters);
    },

    fetchLeavesList(context, filters) {
        return Leaves.objects.filter(filters);
    },

    async fetchJobPostingsFeed(context, filters) {
        return await JobPostingFeed.objects.filter(filters);
    },

    getJobPostingsFeed(context, pk) {
        return JobPostingFeed.objects.get(pk);
    },

    fetchClientWorkforceApplications(context, filters) {
        return ClientWorkforceJobApplication.objects.filter(filters);
    },

    createClientWorkforceApplication(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ClientWorkforceJobApplication.objects.create(form);
    },

    async updateClientWorkforceApplication(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return await ClientWorkforceJobApplication.objects.update({ pk: data.pk }, form);
    },

    updateScheduledInterviewStatus(context, data) {
        const form = new FormData();
        for (let key in data) {
            if (key !== 'pk') form.append(key, data[key]);
        }

        return UpdateScheduledInterviewStatus.objects.update({ pk: data.pk }, form);
    },

    inviteBusinessPartner(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return BusinessPartnerInvite.objects.create(form);
    },

    cancelInviteBusinessPartner(context, filters) {
        return BusinessPartnerInvite.objects.delete(filters);
    },

    fetchExistingBusinessPartnerByEmail(context, filters) {
        return BusinessExistingPartnerByEmail.objects.filter(filters);
    },

    fetchBusinessPartners(context, filters) {
        return BusinessPartnerList.objects.filter(filters);
    },

    createFreeEmployee(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }

        return FreeEmployee.objects.create(form);
    },

    fetchExistingUserByEmail(context, filters) {
        return ExistingUserByEmail.objects.filter(filters);
    },

    checkPhoneNumberExists(context, filters) {
        return ExistingPhoneNumber.objects.filter(filters);
    },

    fetchConflictingScheduledInterviews(context, filters) {
        return CheckConflictingScheduledInterview.objects.filter(filters);
    },

    createJobOfferRequest(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return JobOfferRequest.objects.create(form);
    },

    getJobOfferRequestDetails(context, pk) {
        return JobOfferRequest.objects.get(pk);
    },

    fetchEmploymentPolicyList(context, filters) {
        return StaffConfigurationEmploymentPolicyList.objects.filter(filters);
    },

    fetchPlatformSettingsConfigList(context, filters) {
        return PlatformSettingsList.objects.filter(filters);
    },

    getPlatformSetting(context, pk) {
        return PlatformSettingsDetails.objects.get(pk);
    },

    fetchEmploymentPolicy(context, pk) {
        return StaffConfigurationEmploymentPolicy.objects.get(pk);
    },

    // getStaffConfigDetails(context, pk) {
    //     return StaffConfigDetails.objects.get(pk);

    fetchStaffConfigurationList(context, filters) {
        return StaffConfigurationList.objects.filter(filters);
    },

    async validateStaffConfigurationName(context, filters) {
        const existing = await RenameStaffConfiguration.objects.filter(filters);
        return !!existing.length;
    },

    async renameStaffConfiguration(context, payload) {
        const form = new FormData();

        form.append('workforce_id', payload.workforce_id);
        form.append('name', payload.name);

        return await RenameStaffConfiguration.objects.update({ pk: payload.pk }, form);
    },

    getJobOfferRequestDetails(context, pk) {
        return JobOfferRequest.objects.get(pk);
    },

    fetchBlockedPartnersList(context, filter) {
        return BlockedPartnersList.objects.filter(filter);
    },

    getBlockedPartnerDetails(context, pk) {
        return BlockedPartnersList.objects.get(pk);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
